import type { Selections } from './types';

const STORAGE_KEY = 'veyop_smart_configurator_selections';

/** Selections survive the quick personalizer → full designer hand-off. */
export function readSelections(productId: number): Selections {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_KEY}_${productId}`);
    const parsed = raw ? (JSON.parse(raw) as Selections) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function writeSelections(productId: number, selections: Selections): void {
  try {
    sessionStorage.setItem(`${STORAGE_KEY}_${productId}`, JSON.stringify(selections));
  } catch {
    // Storage full or blocked: selections just are not remembered.
  }
}
